/**
 * Regla ÚNICA de destino posterior al acceso (RN-621, D-319, RF-219).
 *
 * Este archivo es el ÚNICO lugar del frontend que decide a dónde llega la persona
 * después de autenticarse. Existe precisamente porque antes había dos criterios
 * del mismo dato —uno escrito en Acceso.jsx y otro en Asistente.jsx— y dos
 * criterios del mismo dato ya produjeron un defecto en este proyecto.
 *
 * Precedencia (RN-621, en este orden y sin excepciones):
 *   1. Si la persona debe cambiar su contraseña (RN-032, precedencia vigente del
 *      incremento 13/16), el destino es la pantalla de cambio. Esto GANA sobre
 *      todo lo demás y no cambió con D-319.
 *   2. En cualquier otro caso, el destino es el Tablero (/tablero), que es la casa
 *      de la aplicación (RF-208) y el primer destino de la barra aprobada.
 *
 * Ningún otro componente debe calcular este destino: si hace falta un destino
 * nuevo, se agrega aquí.
 */

/** Pantalla de cambio obligatorio de contraseña (precedencia del 13/16, RN-032). */
export const RUTA_DE_CAMBIO_DE_CONTRASENA = '/ajustes/perfil';

/** Casa de la aplicación: destino normal tras autenticarse (RF-208, D-319). */
export const RUTA_DEL_TABLERO = '/tablero';

/**
 * Resuelve el destino posterior al acceso a partir de la sesión recién obtenida.
 *
 * Sirve por igual al inicio de sesión (RN-621.2) y al cierre del asistente de
 * primer arranque (RN-621.3): en el primer arranque la persona acaba de elegir su
 * propia contraseña, así que nunca debe cambiarla y la regla entrega el Tablero.
 *
 * @param {{ debeCambiarContrasena?: boolean } | null | undefined} sesion
 * @returns {string} ruta de destino
 */
export function resolverDestinoPosteriorAlAcceso(sesion) {
  if (sesion?.debeCambiarContrasena === true) return RUTA_DE_CAMBIO_DE_CONTRASENA;
  return RUTA_DEL_TABLERO;
}
